import React from 'react';

export default function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-ring" />
      <img src="/logo.png" alt="Karali" style={{ width: 120, opacity: 0.85 }} />
    </div>
  );
}
